enum ProductCardVariantEnum {
  Article = 'article',
  Default = 'default',
  Tall = 'tall',
  TallOnDesktopOnly = 'tall-desktop',
}

export default ProductCardVariantEnum;
